import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  TrendingUp,
  ArrowRightLeft,
  Users,
  FileText,
  Bell,
  Upload,
  Settings,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Dashboard', href: '/app/dashboard', icon: LayoutDashboard },
  { name: 'Positions', href: '/app/positions', icon: TrendingUp },
  { name: 'Transactions', href: '/app/transactions', icon: ArrowRightLeft },
  { name: 'Clients', href: '/app/clients', icon: Users },
  { name: 'Contracts', href: '/app/contracts', icon: FileText },
  { name: 'Alerts', href: '/app/alerts', icon: Bell },
  { name: 'Import', href: '/app/import', icon: Upload },
];

export function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-card border-r">
        <div className="flex h-16 items-center gap-2 border-b px-6">
          <TrendingUp className="h-6 w-6 text-primary" />
          <span className="text-lg font-semibold">PositionIQ</span>
        </div>

        <nav className="flex flex-col gap-1 p-4">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                )}
              >
                <item.icon className="h-4 w-4" />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-4 left-4 right-4">
          <Link
            to="/app/settings"
            className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
          >
            <Settings className="h-4 w-4" />
            Settings
          </Link>
        </div>
      </aside>

      {/* Main content */}
      <main className="pl-64">
        <header className="sticky top-0 z-40 flex h-16 items-center gap-4 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-6">
          <div className="flex-1">
            <h1 className="text-lg font-semibold">
              {navigation.find((n) => n.href === location.pathname)?.name || 'PositionIQ'}
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <AlertBadge />
            <UserMenu />
          </div>
        </header>

        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function AlertBadge() {
  // TODO: Fetch from API
  const unacknowledgedCount = 3;

  return (
    <Link
      to="/app/alerts"
      className="relative flex items-center justify-center h-9 w-9 rounded-lg hover:bg-muted transition-colors"
    >
      <Bell className="h-5 w-5" />
      {unacknowledgedCount > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-xs text-destructive-foreground">
          {unacknowledgedCount > 9 ? '9+' : unacknowledgedCount}
        </span>
      )}
    </Link>
  );
}

function UserMenu() {
  return (
    <div className="flex items-center gap-2">
      <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
        <span className="text-sm font-medium">U</span>
      </div>
    </div>
  );
}
